import React from "react";
import PageLayout from "../../layouts/PageLayout";
import { Heading } from "../../components/elements";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

export default function TutAr() {
    return (
        <PageLayout>
          <Helmet>
            <title>Free Blockchain Course</title>
            <meta name="description" content="Step-by-step course to build and launch your own crypto project. Learn token creation, airdrops, and more—no coding required!" />
            <meta name="keywords" content="React, SEO, Web Development, Meta Tags" />
            <meta name="author" content="0xFactory" />

            {/* Open Graph (for Facebook, LinkedIn, etc.) */}
            <meta property="og:title" content="Learn to Build & Launch a Crypto Project" />
            <meta property="og:description" content="Step-by-step course to build and launch your own crypto project. Learn token creation, airdrops, and more—no coding required!" />
            <meta property="og:image" content="https://i.ibb.co/3YGHzKfZ/course.png" />
            <meta property="og:url" content="https://0xfactory.com/video-tutorials" />
            <meta property="og:type" content="website" />

            {/* Twitter Card (for Twitter sharing) */}
            <meta name="twitter:title" content="Learn to Build & Launch a Crypto Project" />
            <meta name="twitter:description" content="Step-by-step course to build and launch your own crypto project. Learn token creation, airdrops, and more—no coding required!" />
            <meta name="twitter:image" content="https://i.ibb.co/3YGHzKfZ/course.png" />
            <meta name="twitter:card" content="crypto_course" />
          </Helmet>
            <Container fluid>
                <Heading as="h2" className="mc-overview-title">كورس بلوكتشين</Heading>
                    <Row xs={1} sm={2} xl={2}>
                            <Col xs={12} sm={12} xl={12}>

                                <div className="text-center">
                                  تعلم كيف تنشئ مشروعك بنفسك، ستتعلم كيف تنشئ عملتك الرقمية و موقع إكتتاب لبيع عملتك و موقع إيردروب لتوزيع العملة و العديد من الموضوعات المفيدة
                                </div>
                                <br/>
                                <br/>

                                <div className="text-center">
                                    <h2>كيف تنشئ عملتك الرقمية</h2>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <iframe width="560" height="315" src="https://www.youtube.com/embed/JWxDFp00h48?si=oyGQDFWFBoM2zXs-" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>

                                <br/>
                                <br/>
                                <div className="text-center">
                                    <h2>كيف تنشئ موقع إكتتاب لبيع عملتك</h2>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <iframe width="560" height="315" src="https://www.youtube.com/embed/KRvwFAHoerk?si=TPm3cPHh_sbqJ1tA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>

                                <br/>
                                <br/>
                                <div className="text-center">
                                    <h2>كيف تنشئ موقع إيردروب لتوزيع عملتك</h2>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <iframe width="560" height="315" src="https://www.youtube.com/embed/RV1srx8nGbk?si=-UlzWOrb2QsrpQH9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>

                                <br/>
                                <br/>
                                <div className="text-center">
                                    <h2>إنشئ موقع لعملتك الرقمية</h2>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <iframe width="560" height="315" src="https://www.youtube.com/embed/FJgJk0pukyw?si=qFNz8QYFoKpxL3X8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>


                            </Col>
                    </Row>
                </Container>
        </PageLayout>
    )
}
